import doGet from './get'
import doPut from './put'
import doPost from './post'
import doDelete from './delete'

export default {
  doGet,
  doPut,
  doPost,
  doDelete
}
